import { Component, OnInit } from "@angular/core";
import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";

import { PersonalInformationDetails } from "../../../shared/models";
import {
	FormGroup,
	Validators,
	AbstractControl,
	ValidationErrors,
	AsyncValidatorFn
} from "@angular/forms";
import { CustomerAddress } from "../../../shared/models/my-account-data.models";
import {
	debounceTime,
	distinctUntilChanged,
	switchMap,
	map
} from "rxjs/operators";
import { Observable, timer } from "rxjs";
import { PersonalInfoService } from "./personal-info.service";
import { AcepSSOService } from "@acepteam/globalspack";
import { AddressComponent } from "../_common";
import { $ } from "protractor";
import { MatDatepicker } from "@angular/material/datepicker";
import { environment } from "src/environments/environment";

declare var moment;

//used for searching existing contact records with  same npi/email
export function existingTokenValidator(
	personalInfoService: PersonalInfoService,
	acepId: string,
	tokenType: string
): AsyncValidatorFn {
	return (
		control: AbstractControl
	):
		| Promise<ValidationErrors | null>
		| Observable<ValidationErrors | null> => {
		let debounceTime = 500; //milliseconds
		return timer(debounceTime).pipe(
			switchMap(() => {
				return personalInfoService
					.searchContact(control.value, tokenType)
					.pipe(
						map(response => {
							return response != null &&
								response.length > 0 &&
								response[0].acepid != acepId
								? { tokenTaken: true }
								: null;
						})
					);
			})
		);
	};
}

@Component({
	selector: "app-personal-info",
	templateUrl: "./personal-info.component.html",
	styleUrls: ["./personal-info.component.scss"]
})
export class PersonalInfoComponent extends MemberappBaseComponent {
	personalInfo: PersonalInformationDetails;
	personalInfoForm: FormGroup;

	ui_Prefix = this.dataService.uidata.Prefix;
	ui_Gender = this.dataService.uidata.Gender;
	ui_Ethnicity = this.dataService.uidata.Ethnicity;

	ui_Pronouns = this.dataService.uidata.Pronouns;
	ui_SexualOrientations = this.dataService.uidata.SexualOrientations;
	ui_PrimaryLanguages = this.dataService.uidata.PrimaryLanguages;
	ui_Disabilities = this.dataService.uidata.Disabilities;
	ui_PrimaryPracticeGeography = this.dataService.uidata.PrimaryPracticeGeography;
	ui_PrimaryPracticeSettings = this.dataService.uidata.PrimaryPracticeSettings;
	ui_PrimaryReasonForJoining = this.dataService.uidata.PrimaryReasonForJoining;

	//pga: Coding-3742 Privacy Policy Url
	ui_PrivacyURL = environment.PrivacyPolicyURL;

	get phoneType() {
		return this.personalInfoForm.get("phoneType");
	}
	get prefix() {
		return this.personalInfoForm.get("prefix");
	}
	get addressType() {
		return this.personalInfoForm.get("customerAddress.addresstype");
	}
	get npi() {
		return this.personalInfoForm.get("npi");
	}
	get email() {
		return this.personalInfoForm.get("email");
	}

	get primaryReasonForJoining() {
		return this.personalInfoForm.get("primaryReasonForJoining");
	}

	ngOnInit() {
		//this.loggerService.logInfo(this.memberAppDataService.memberAppData);

		//reset
		this.resetForm();

		//subscriptions

		// this.subscriptions.push(this.npi.valueChanges.pipe(
		//   // wait 300ms after each keystroke before considering the term
		//   debounceTime(300),

		//   // ignore new term if same as previous term
		//   distinctUntilChanged(),

		//   // switch to new search observable each time the term changes
		//   switchMap((term: string) => this.personalInfoService.searchNpi(term)),
		// ).subscribe( (response: any) =>
		// {
		//  // this.npi.setErrors({"npiTaken": false});

		//   console.log(response)
		//   if(response != null && response.acepid != this.ssoService.acepid)
		//   {
		//    // this.npi.setErrors({"npiTaken": true});
		//     this.globalDomOpsService.notify("Another Record found with provided NPI Number","","error");

		//   }
		// }

		// ));
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
		this.memberAppDomService.initPersonalInfoStyles();
		//$('.cdk-overlay-pane.mat-datepicker-popup').is(':visible');
	}

	resetForm() {
		this.personalInfo = this.memberAppDataService.memberAppData.personalInfo;

		this.personalInfoForm = this.fb.group({
			prefix: [this.personalInfo.prefix, Validators.required],
			firstName: [this.personalInfo.firstName, Validators.required],
			middleName: [this.personalInfo.middleName],
			lastName: [this.personalInfo.lastName, Validators.required],
			suffix: [this.personalInfo.suffix],
			jobTitle: [this.personalInfo.jobTitle],
			npi: [
				this.personalInfo.npi,
				Validators.pattern(`^[0-9]{10}$`),
				[
					existingTokenValidator(
						this.personalInfoService,
						this.ssoService.acepid,
						"npi"
					)
				]
			], //async validators]
			dateOfBirth: [new Date(this.personalInfo.dateOfBirth)],
			gender: [this.personalInfo.gender],
			ethnicity: [this.personalInfo.ethnicity],

			customerAddress: this.fb.group({
				addressid: this.personalInfo.customerAddress.addressid,
				addresstype: [
					this.personalInfo.customerAddress.addresstype,
					Validators.required
				],
				address: AddressComponent.buildForm(
					this.personalInfo.customerAddress.address,
					this.fb,
					true
				)
			}),

			email: [
				this.personalInfo.email,
				[Validators.required, Validators.email],
				[
					existingTokenValidator(
						this.personalInfoService,
						this.ssoService.acepid,
						"email"
					)
				]
			],
			phoneType: [this.personalInfo.phoneType],
			phone: [this.personalInfo.phone],

			sexualOrientation: this.personalInfo.sexualOrientation,
			primaryLanguage: this.personalInfo.primaryLanguage,
			disability: this.personalInfo.disability,
			pronoun: this.personalInfo.pronoun,

			//About My Career
			primaryPracticeGeography: this.personalInfo.primaryPracticeGeography,
			primaryPracticeSetting: this.personalInfo.primaryPracticeSetting,
			primaryReasonForJoining: [
				this.personalInfo.primaryReasonForJoining,
				Validators.required
			]

		});
	}

	refreshAddress() {
		let addr: string = this.addressType.value;
		let ca: CustomerAddress = this.personalInfoService.GetAddressByAddressType(
			addr
		);
		this.personalInfoForm.patchValue({ customerAddress: ca });
		//state is getting reset by country subscription. so set it explicitly
		this.personalInfoForm
			.get("customerAddress.address.state")
			.setValue(ca.address.state);
	}

	refreshPhones() {
		let phonetype: string = this.phoneType.value;
		let ph: string = this.personalInfoService.GetPhoneByPhoneType(
			phonetype
		);
		this.personalInfoForm.patchValue({
			phone: ph
		});
	}

	prepareDataModel(): PersonalInformationDetails {
		let p: PersonalInformationDetails = Object.assign(
			{},
			this.personalInfo,
			this.personalInfoForm.value
		) as PersonalInformationDetails;
		p.customerAddress = Object.assign({}, p.customerAddress);
		p.customerAddress.isprimary = true;
		p.dateOfBirth = this.commonOpsService.SantizeDate(p.dateOfBirth);
		return p;
	}

	save() {
		super.onSave(this.personalInfoForm);

		if (this.personalInfoForm.valid) {
			if (this.personalInfoForm.dirty) {
				// Copy the form values over the product object values
				this.personalInfo = this.prepareDataModel();
				this.loggerService.logInfo(this.personalInfo);
				this.personalInfoService
					.savePersonalInformation(this.personalInfo)
					.subscribe(
						d => {
							this.onSaveComplete(d);
						},
						(error: any) => {
							this.errorMessage = <any>error;
							super.onError();
						}
					);
			} else {
				this.onSaveComplete();
			}
		}
	}

	onSaveComplete(d?: PersonalInformationDetails) {
		if (!!d) {
			//ACTUAL SAVE CALL WAS SENT TO DB
			this.personalInfo.customerAddress.addressid =
				d.customerAddress.addressid;
		}
		this.memberAppDataService.memberAppData.personalInfo = this.personalInfo;

		//Update addresses Data Set
		this.personalInfoService.UpdateMemberAppData_Address(
			this.personalInfo.customerAddress
		);

		//Update phones Data Set
		this.personalInfoService.UpdateMemberAppData_Phones(
			this.personalInfo.phoneType,
			this.personalInfo.phone
		);

		this.globalDomOpsService.notify("Personal Information Updated");
		this.memberAppDataService.navigateToRoute("membership");
	}
}
